<template>
  <div class="flex items-center">
    <!--<status-leilao-icon class="fa-fw" :status="status" />-->
    <span :class="'scolor leilao-status leilao-status-' + status">{{getStatus(status).title}}</span>
  </div>
</template>

<script>
import {Status, getStatus} from '../../../../domain/leiloes/helpers/LeilaoStatus'
// import StatusLeilaoIcon from './StatusLeilaoIcon'

export default {
  name: 'StatusLeilaoSelector',
  components: {/* StatusLeilaoIcon */},
  props: ['status'],
  computed: {
  },
  methods: {
    getStatus (s) {
      return getStatus(s, Status)
    }
  }
}
</script>

<style scoped>

</style>
